import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginRegisterAction } from "../../../../../redux/user/userActions";
import {
  CustomTextField,
  Form,
  SubmitButton,
} from "../../../../../utils/formGenerator";
import { LoginSchema } from "../../../../../utils/validationsSchema";
import { useRegisterActions } from "../../../../components/contexts/authContext/AuthContextProvider";

function Step1() {
  const { setPhoneNumberAction, setStep } = useRegisterActions();
  const [initialValues, setInitialValues] = useState({
    phone_number: "",
  });

  const dispatch = useDispatch();

  const handleChange = (e) => {
    setInitialValues({
      ...initialValues,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (values, { setSubmitting, resetForm, setStatus }) => {
    setSubmitting(true);
    dispatch(loginRegisterAction(values, setPhoneNumberAction, setStep));
    setSubmitting(false);
  };

  return (
    <div>
      {/* <p className="text-muted font-weight-bold">
        شماره همراه خود را وارد نمایید
      </p> */}
      <Form
        enableReinitialize
        initialValues={initialValues}
        validationSchema={LoginSchema}
        onSubmit={onSubmit}
      >
        <CustomTextField
          label="شماره همراه"
          name="phone_number"
          placeholder="شماره همراه خود را وارد نمایید"
          value={initialValues.phone_number}
          handleChange={handleChange}
          margin="normal"
        />
        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
          {/* <Link
            to="/forgot-password"
            className="text-dark-50 text-hover-warning my-3 mr-2"
            id="kt_login_forgot"
          >
            فراموشی رمز عبور
          </Link> */}
          <SubmitButton
            title="ارسال"
            className=" btn-bg-gold"
            type="submit"
            variant="contained"
            size="large"
            // loading={step1Loading}
          />
        </div>
      </Form>
    </div>
  );
}

export default Step1;
